// import { RFC_2822 } from "moment";

export default Object.freeze({
  CONFIG: {
    STAFF_SUPPORT_FAMILY: 10,
  },
  PAGES: {
    HOME: "/Home",
    LOGIN: "/",
    MANAGER_LOGIN: "/manager",
    MANAGER_HOME: "/manager/Home",
    APPLICATION_REGIST: "/ApplicationRegist",
    MANAGER_APPLICATION_REGIST: "/manager/ApplicationRegist",
    WORK_REGIST: "/WorkRegist",
    MANAGER_WORK_REGIST: "/manager/WorkRegist",
  },
  URL: {
    // API
    LOGIN: "/api/login",
    LOGIN_SYSTEM_USER: "/api/login_system_user",
    LOGOUT: "/api/logout",
    HOME_INFO: "/api/home_info",
    WORK_CONFIRME: "/api/work_confirme",
    WORK_REGIST: "/api/work_regist",
    WORK_EDIT: "/api/work_edit",
    WORK_DELETE: "/api/work_delete",
    CALENDAR: "/api/calendar",
    ATTENDANCE_CHECK: "/api/attendance_check",
    WORK_STATUS: "/api/work_status",
    KOUJI_LIST: "api/kouji_list",
    KOUJI_INFO: "/api/kouji_info",
    COPY_LAST_DAY: "/api/copy_last_day",
    LOGIN_INFO: "/api/login_info", 
    SEND_MAIL_WORK_INFO: "/api/send_mail_work_info",
    CHANGE_PASSWORD: "/api/login_info/change_pw",
    HOME_INFO_MANAGER: "/api/home_info/manager",
    SEND_MAIL_WORK_INFO_UNLOCK: "/api/send_mail_work_info/unlock",

    APPLICATION_REGIST: "/api/application_regist",
    APPROVAL_REGIST_COUNT: "/api/approval_regist/approve_count",
    APPROVAL_REGIST_APPLICATION: "/api/approval_regist/application",
    APPROVAL_REGIST_WORK: "/api/approval_regist/work",
    SUBSTITUTE_HOLIDAY_MANAGE_SHAIN_LIST:"/api/substitute_holiday_manage/shain_list",
    SUBSTITUTE_HOLIDAY_MANAGE_PERSONAL_INFO:"/api/substitute_holiday_manage/personal_info",
    SUBSTITUTE_HOLODAY_MANAGE_CHECK_MATCH_INFO: "/api/substitute_holiday_manage/check_match_info",
    SUBSTITUTE_HOLIDAY_MANAGE:"/api/substitute_holiday_manage",
    WORK_SUMMARY: "/api/work_summary",
    USER_INFO_DATE_TYPE: "/api/user_info/date_type",
    USER_INFO_TRANSFER_WORK_LIST: "/api/user_info/transfer_work_list",
    USER_INFO_MEMBER_LIST: "/api/user_info/member_list",
  },
  PROCESS: {
    LOGIN: "/login",
    LOGOUT: "/logout",

    GET: "/get",
    UPDATE: "/update",
    INSERT: "/insert",
    SAVE: "/save",
    COPY: "/copy",
    DELETE: "/delete",
    COUNT: "/count",
    SEARCH: "/search",
    UPLOAD: "/upload",
    LIST: "/list",
    CHECK: "/check",
  },
  MODE: {
    CREATE: "1",
    UPDATE: "2",
  },
  VALUE: {
    //----共通
    // 有り
    EXIST: "1",
    // 無し
    NOT_EXIST: "0",
    // 対象
    IS_APPLICABLE: 1,
    // 対象外
    IS_NOT_APPLICABLE: 0,

    // ユーザ権限
    SYSTEM_USER_LEVEL_CHARGER: 1,

    // 画面種別: 報告
    DISPLAY_TYPE_WORK: 1,
    // 画面種別: 事前申請
    DISPLAY_TYPE_APPLICATION: 2,

    // 画面種別(承認): 事前申請
    DISPLAY_APPROVAL_TYPE_APPLICATION: "1",
    // 画面種別(承認): 報告
    DISPLAY_APPROVAL_TYPE_WORK: "2",

    // 表示タブ切り替えモード(承認): 画面初期表示
    DISPLAY_APPROVAL_TAB_TYPE_INITIAL_DISPLAY: 0,
    // 表示タブ切り替えモード(承認): 承認処理後
    DISPLAY_APPROVAL_TAB_TYPE_AFTER_APPROVAL: 1,

    // 画面表示種別(承認): 承認
    DISPLAY_APPROVAL_SCREEN_TYPE_APPROVAL: 0,
    // 画面表示種別(承認): 承認状況
    DISPLAY_APPROVAL_SCREEN_TYPE_APPLICATION_HISTORY: 1,
    // 画面表示種別(承認): 承認履歴
    DISPLAY_APPROVAL_SCREEN_TYPE_APPROVAL_HISTORY: 2,

    // 休日区分: 平日
    DATE_TYPE_WEEKDAY: 0,
    // 休日区分: 休日
    DATE_TYPE_HOLIDAY: 1,
    // 休日区分: 公休
    DATE_TYPE_PUBLIC_HOLIDAY: 2,

    // 承認区分: 未承認
    APPROVAL_TYPE_NON_APPROVAL: 0,
    // 承認区分: 承認
    APPROVAL_TYPE_APPROVAL: 1,
    // 承認区分: 否認
    APPROVAL_TYPE_REJECTION: 9,

    //---
    // Element io アラートメッセージ
    TITLE_WARNING: "",
    TITLE_SUCCESS: "",
    OK: "OK",
    CANCEL: "キャンセル",
    ALERT_TYPE_SUCCESS: "success",
    ALERT_TYPE_WARNING: "warning",
    ALERT_TYPE_ERROR: "error",
  },
  //ヘルプキー
  HELP: {
    BASE_URL: "",
    KEYWORD: {},
  },
  OPTIONS: {
    OPTION_NOT_SELECT: [{ value: null, text: "( 未選択 )" }],
    // 勤務区分
    WORK_SEGMENT: [
      { value: 1, text: "出勤" },
      { value: 11, text: "休日出勤（振替）" },
      { value: 12, text: "休日出勤（残業）" },
      { value: 21, text: "公休出勤（振替）" },
      { value: 22, text: "公休出勤（残業）" },
      { value: 3, text: "欠勤" },
      { value: 4, text: "有休" },
      { value: 5, text: "特休" },
      { value: 6, text: "他振" },
      { value: 7, text: "振休" },
      { value: 8, text: "×", disabled: true },
      { value: 9, text: "★その他" },
    ],
    WORK_SEGMENT_WEEKDAY: [
      { value: 1, text: "出勤" },
      { value: 3, text: "欠勤" },
      { value: 4, text: "有休" },
      { value: 5, text: "特休" },
      { value: 6, text: "他振" },
      { value: 7, text: "振休" },
      { value: 8, text: "×", disabled: true },
      { value: 9, text: "★その他" },
    ],
    WORK_SEGMENT_HOLIDAY: [
      { value: 11, text: "休日出勤（振替）" },
      { value: 12, text: "休日出勤（残業）" },
    ],
    WORK_SEGMENT_PUBLIC_HOLIDAY: [
      { value: 21, text: "公休出勤（振替）" },
      { value: 22, text: "公休出勤（残業）" },
    ],
    WORK_SEGMENT_SIMPLE: [
      { value: null, text: "-" },
      { value: 1, text: "出勤" },
      { value: 11, text: "休出" },
      { value: 12, text: "休出" },
      { value: 21, text: "公出" },
      { value: 22, text: "公出" },
      { value: 3, text: "欠勤" },
      { value: 4, text: "有休" },
      { value: 5, text: "特休" },
      { value: 6, text: "他振" },
      { value: 7, text: "振休" },
      { value: 8, text: "×", disabled: true },
      { value: 9, text: "★他" },
    ],
    // 申請区分
    APPLIATION_SEGMENT: [
      { value: 1, text: "早出" },
      { value: 2, text: "残業" },
      { value: 11, text: "休日出勤（振替）" },
      { value: 12, text: "休日出勤（残業）" },
      { value: 21, text: "公休出勤（振替）" },
      { value: 22, text: "公休出勤（残業）" },
      { value: 3, text: "欠勤" },
      { value: 4, text: "有休" },
      { value: 5, text: "特休" },
      { value: 6, text: "他振" },
      { value: 7, text: "振休" },
      { value: 8, text: "×", disabled: true },
      { value: 9, text: "★その他" },
    ],
    APPLIATION_SEGMENT_WEEKDAY: [
      { value: 1, text: "早出" },
      { value: 2, text: "残業" },
      { value: 3, text: "欠勤" },
      { value: 4, text: "有休" },
      { value: 5, text: "特休" },
      { value: 6, text: "他振" },
      { value: 7, text: "振休" },
      { value: 8, text: "×", disabled: true },
      { value: 9, text: "★その他" },
    ],
    APPLIATION_SEGMENT_HOLIDAY: [
      { value: 11, text: "休日出勤（振替）" },
      { value: 12, text: "休日出勤（残業）" },
    ],
    APPLIATION_SEGMENT_PUBLIC_HOLIDAY: [
      { value: 21, text: "公休出勤（振替）" },
      { value: 22, text: "公休出勤（残業）" },
    ],
    // 勤務承認区分
    APPLICATION_SEGMENT_SIMPLE: [
      { value: 1, text: "早出" },
      { value: 2, text: "残業" },
      { value: 11, text: "休出(振替)" },
      { value: 12, text: "休出(残業)" },
      { value: 21, text: "公出(振替)" },
      { value: 22, text: "公出(残業)" },
      { value: 3, text: "欠勤" },
      { value: 4, text: "有休" },
      { value: 5, text: "特休" },
      { value: 6, text: "他振" },
      { value: 7, text: "振休" },
      { value: 8, text: "×", disabled: true },
      { value: 9, text: "★その他" },
    ],
    //都道府県
    PREFECTURES: [
      { value: "01", text: "北海道" },
      { value: "02", text: "青森県" },
      { value: "03", text: "岩手県" },
      { value: "04", text: "宮城県" },
      { value: "05", text: "秋田県" },
      { value: "06", text: "山形県" },
      { value: "07", text: "福島県" },
      { value: "08", text: "茨城県" },
      { value: "09", text: "栃木県" },
      { value: "10", text: "群馬県" },
      { value: "11", text: "埼玉県" },
      { value: "12", text: "千葉県" },
      { value: "13", text: "東京都" },
      { value: "14", text: "神奈川県" },
      { value: "15", text: "新潟県" },
      { value: "16", text: "富山県" },
      { value: "17", text: "石川県" },
      { value: "18", text: "福井県" },
      { value: "19", text: "山梨県" },
      { value: "20", text: "長野県" },
      { value: "21", text: "岐阜県" },
      { value: "22", text: "静岡県" },
      { value: "23", text: "愛知県" },
      { value: "24", text: "三重県" },
      { value: "25", text: "滋賀県" },
      { value: "26", text: "京都府" },
      { value: "27", text: "大阪府" },
      { value: "28", text: "兵庫県" },
      { value: "29", text: "奈良県" },
      { value: "30", text: "和歌山県" },
      { value: "31", text: "鳥取県" },
      { value: "32", text: "島根県" },
      { value: "33", text: "岡山県" },
      { value: "34", text: "広島県" },
      { value: "35", text: "山口県" },
      { value: "36", text: "徳島県" },
      { value: "37", text: "香川県" },
      { value: "38", text: "愛媛県" },
      { value: "39", text: "高知県" },
      { value: "40", text: "福岡県" },
      { value: "41", text: "佐賀県" },
      { value: "42", text: "長崎県" },
      { value: "43", text: "熊本県" },
      { value: "44", text: "大分県" },
      { value: "45", text: "宮崎県" },
      { value: "46", text: "鹿児島県" },
      { value: "47", text: "沖縄県" },
    ],
  },
  MESSAGE: {
    SERVER_ERROR: "処理中に問題が発生しました。お手数ですが、再度お試しください。",
    AUTHENTICATION_ERROR: "ユーザーの認証に失敗しました。再度ログインしてください。",
    DATA_UPDATED: "データが更新されました。",
    //
    DATA_NOT_FOUND_BEFORE_MONTH: "前月データが存在しません。",
    REGISTER_CONFIRMATION: "この情報は間違いないですか？",
  },
  STORE: {
    INDEX: {
      ACTION: {
        startLoading: "startLoading",
        stopLoading: "stopLoading",
        authErrorModalShow: "authErrorModalShow",
        authErrorModalHide: "authErrorModalHide",
        serverErrorModalShow: "serverErrorModalShow",
        serverErrorModalHide: "serverErrorModalHide",
      },
    },
    USER_INFO: {
      MUTATIONS: {
        setUserInfo: "userInfo/setUserInfo",
        logOut: "userInfo/logOut",
      },
    },
  },
});
